<template>
  <div class="homepage">
  <el-container class="all">
    <left></left>

  <el-container class="cow">
    <el-header style="height: auto; padding: 0;">
     <right></right></el-header>
     <!-- <tabs></tabs> -->
     <el-main style="overflow: hidden;">
     <router-view></router-view>

     </el-main>

    </el-container>

  </el-container>

</div>
</template>

<script>
import Left from './index/left.vue'
import right from './index/right.vue'
export default {
  components: {
    Left, right
  }

}
</script>

<style>
.el-main {
  overflow: auto;
  width: 100%;
  height:100vh;
}
.element.style{
  height:0;
}
.el-header{
  width:100%;
  height:100px;
  margin:0;
  padding: 0;

}
.all{
  width:100vw;
   overflow:hidden;
}
.cow{
 display: flex;
 flex-wrap: wrap;
 flex:1;
 width:auto;
 /* flex-direction: column;
 flex:1;
  width:auto;  */

}

</style>
